import * as React from 'react';
import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel, UIComponentProps, UIComponentState } from '../uicomponent';
import { LoaderCSSStyle } from './loadercss';
import './loadercss.css';


export class LoaderViewImpl extends UIComponentViewImpl<UIDataModel>
{
    draw(props: UIComponentProps, state: UIComponentState, cssStyle: LoaderCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                <div className="loader" />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/loader/loaderview.tsx